import {useContext, useEffect, useState} from 'react'
import {Col, Form, Row, Stack} from 'react-bootstrap'
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import {KTIcon} from '../../../../../_metronic/helpers'
import {useUserInfo} from '../../../../routing/store/InfoUserProvider'
import {generateLoadExcel} from '../../../../services/documentos'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../../../../services/menu'
import {useGlobalOverlayLoading} from '../../../../shared/hooks/useGlobalOverlayLoading'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {DataUser} from '../../../documentacion/MiFicha/DataUserInterface'
import {DatePickerBusiness} from '../../../generales_component/DatePickerBusiness'
import {PartnerContext} from '../PartnerContexts'

const DocumentsListHeader = () => {
  const buttonsData = [
    {
      iconName: 'verify',
      title: 'Borrador',
      stateName: 'borrador',
      color: '#f39c12', // Orange
    },
    {
      iconName: 'security-user',
      title: 'Enviado',
      stateName: 'completado',
      color: '#2ecc71', // Green
    },
  ]

  const {procesosAdmin, unidadesGrouped} = useUserInfo()
  const {setGlobalOverlayLoading} = useGlobalOverlayLoading()
  const location = useLocation()
  const {selectedRole, selectedCompanyId} = useAuth2()
  const [permissions, setPermissions] = useState<string[]>([])
  const usuarioJSON = localStorage.getItem('userData')
  const [searchParams] = useSearchParams()

  let usuario: DataUser | null = null

  if (usuarioJSON !== null) {
    usuario = JSON.parse(usuarioJSON)
  }
  useEffect(() => {
    const fetchPermissions = async () => {
      const response = await fetchMenuActionsByRole(selectedRole)
      if (response.success) {
        const currentPath = location.pathname
        console.log('currentpath' + JSON.stringify(currentPath))
        const subMenuResponse = await fetchSubMenuByUrl(currentPath)
        if (subMenuResponse.success) {
          console.log('PERMISOS' + JSON.stringify(subMenuResponse))
          const subMenuId = subMenuResponse.data.id_hijo
          const permissionsForSubMenu =
            response.data.find((item: any) => item.subMenuId === subMenuId)?.acciones || []
          setPermissions(permissionsForSubMenu)
        }
      }
    }

    fetchPermissions()
  }, [selectedRole])

  const navigate = useNavigate()

  const {
    idProceso,
    setIdProceso,
    setState,
    setSearchTerm,
    setUnidad,
    Dates,
    setDates,
    setCurrentPage,
    searchTerm,
  } = useContext(PartnerContext)

  const handleSearch = (value: string) => {
    setSearchTerm(value)
    setCurrentPage(1)
  }

  const handleProcessChange = (e: any) => {
    setIdProceso(e.target.value)
    setCurrentPage(1)
  }

  const handleUnitChange = (e: any) => {
    setUnidad(e.target.value)
    setCurrentPage(1)
  }

  const handleStateChange = (e: any) => {
    setState(e.target.value)
    setCurrentPage(1)
  }

  const handleExport = (id: any) => {
    setGlobalOverlayLoading(true)
    generateLoadExcel({})
      .then((response) => console.log(response))
      .catch((error) => console.log(error))
      .finally(() => setGlobalOverlayLoading(false))
  }

  const handleSend = () => {
    navigate('/configuracion/enviodocumentos')
  }

  const handleDateChange = (dates: any) => {
    setDates(dates)
    setCurrentPage(1)
  }

  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row className='mb-4'>
          <Col>
            <Stack direction='vertical' className='h-100' gap={3}>
              <span className='fw-bold me-2'>Proceso:</span>
              <Form.Control
                as='select'
                onChange={handleProcessChange}
                className={'form-select form-select-solid}'}
                style={{minWidth: '200px'}}
              >
                <option value=''>Seleccione un proceso</option>
                {procesosAdmin.map((process) => (
                  <option value={process.id} key={process.id}>
                    {process.name}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3}>
              <span className='fw-bold me-2'>Unidad:</span>
              <Form.Control
                as='select'
                onChange={handleUnitChange}
                className={'form-select form-select-solid}'}
                style={{minWidth: '200px'}}
              >
                <option value=''>Seleccione una unidad</option>
                {unidadesGrouped[idProceso]?.map((unit) => (
                  <option value={unit.id} key={unit.id}>
                    {unit.name}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical' gap={3}>
              <span className='fw-bold'>Buscar</span>
              <Form.Control
                type='text'
                className={'form-control-sm same-height'}
                placeholder='Buscar Nombre de Paquete'
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                // searchTermDef={searchParams.get('nombre') ?? ''}
              />
            </Stack>
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <Stack direction='vertical'>
              <span className='fw-bold'>Rangos de Fecha de Carga</span>
              <DatePickerBusiness
                className='flex-grow-1'
                value={Dates}
                onChange={handleDateChange}
              />
            </Stack>
          </Col>
          <Col>
            <Stack direction='vertical'>
              <span className='fw-bold'>Estado:</span>
              <Form.Control
                className={'form-select form-select-solid}'}
                as='select'
                onChange={handleStateChange}
              >
                <option value=''>Todos</option>
                {buttonsData.map((option) => (
                  <option
                    key={option.iconName}
                    value={option.stateName}
                    style={{color: option.color}}
                  >
                    {option.title}
                  </option>
                ))}
              </Form.Control>
            </Stack>
          </Col>
          <Col className='d-flex align-items-end justify-content-end gap-3'>
            <button type='button' className='btn btn-primary me-2' onClick={handleSend}>
              <KTIcon iconName='' className='fs-2' />
              Envío de documentos
            </button>

            {permissions.includes('Exportar') && (
              <button type='button' className='btn btn-primary' onClick={handleExport}>
                <KTIcon iconName='file-down' className='fs-2' />
                Exportar
              </button>
            )}
          </Col>
        </Row>
      </div>
    </>
  )
}

export {DocumentsListHeader}
